import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";

const ClawbackSmsRcsModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [formData, setFormData] = useState({
    currentSmsCount: "",
    currentRcsBalance: "",
    smsClawback: "",
    rcsClawback: "",
    closingSmsBalance: "",
    closingRcsBalance: "",
  });

  const [errors, setErrors] = useState({
    currentSmsCount: "",
    currentRcsBalance: "",
    smsClawback: "",
    rcsClawback: "",
    closingSmsBalance: "",
    closingRcsBalance: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    // Calculate closing balances whenever smsClawback or rcsClawback changes
    setFormData((prev) => ({
      ...prev,
      closingSmsBalance: prev.smsClawback
        ? parseInt(columnData?.smsBalance || 0) -
          parseInt(prev.smsClawback || 0)
        : "",
      closingRcsBalance: prev.rcsClawback
        ? parseInt(columnData?.rcsBalance || 0) -
          parseInt(prev.rcsClawback || 0)
        : "",
    }));
  }, [formData.smsClawback, formData.rcsClawback, columnData]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    setFormData((prev) => ({
      ...prev,
      [id]: updatedValue,
    }));
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    // Check if at least one of smsClawback or rcsClawback is filled
    if (!formData.smsClawback && !formData.rcsClawback) {
      newErrors.smsClawback =
        "At least one of SMS Clawback or RCS Clawback is required";
      newErrors.rcsClawback =
        "At least one of SMS Clawback or RCS Clawback is required";
    } else {
      // Validate SMS Clawback if provided
      if (formData.smsClawback) {
        if (!/^\d+$/.test(formData.smsClawback)) {
          newErrors.smsClawback = "Only numbers are allowed for SMS Clawback";
        } else if (parseInt(formData.smsClawback, 10) <= 0) {
          newErrors.smsClawback = "Amount must be greater than zero";
        } else if (
          parseInt(formData.smsClawback, 10) >
          parseInt(columnData?.smsBalance || 0)
        ) {
          newErrors.smsClawback = "Clawback cannot exceed current SMS balance";
        }
      }

      // Validate RCS Clawback if provided
      if (formData.rcsClawback) {
        if (!/^\d+$/.test(formData.rcsClawback)) {
          newErrors.rcsClawback = "Only numbers are allowed for RCS Clawback";
        } else if (parseInt(formData.rcsClawback, 10) <= 0) {
          newErrors.rcsClawback = "Amount must be greater than zero";
        } else if (
          parseInt(formData.rcsClawback, 10) >
          parseInt(columnData?.rcsBalance || 0)
        ) {
          newErrors.rcsClawback = "Clawback cannot exceed current RCS balance";
        }
      }
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value?.trim();

    // Clear previous errors for both fields
    fieldErrors.smsClawback = "";
    fieldErrors.rcsClawback = "";

    // Check if at least one field is filled
    if (!formData.smsClawback && !formData.rcsClawback && !trimmedValue) {
      fieldErrors.smsClawback =
        "At least one of SMS Clawback or RCS Clawback is required";
      fieldErrors.rcsClawback =
        "At least one of SMS Clawback or RCS Clawback is required";
    } else {
      // Validate the specific field being blurred
      switch (id) {
        case "smsClawback":
          if (trimmedValue) {
            if (!/^\d+$/.test(trimmedValue)) {
              fieldErrors.smsClawback =
                "Only numbers are allowed for SMS Clawback";
            } else if (parseInt(trimmedValue, 10) <= 0) {
              fieldErrors.smsClawback = "Amount must be greater than zero";
            } else if (
              parseInt(trimmedValue, 10) > parseInt(columnData?.smsBalance || 0)
            ) {
              fieldErrors.smsClawback =
                "Clawback cannot exceed current SMS balance";
            }
          }
          break;

        case "rcsClawback":
          if (trimmedValue) {
            if (!/^\d+$/.test(trimmedValue)) {
              fieldErrors.rcsClawback =
                "Only numbers are allowed for RCS Clawback";
            } else if (parseInt(trimmedValue, 10) <= 0) {
              fieldErrors.rcsClawback = "Amount must be greater than zero";
            } else if (
              parseInt(trimmedValue, 10) > parseInt(columnData?.rcsBalance || 0)
            ) {
              fieldErrors.rcsClawback =
                "Clawback cannot exceed current RCS balance";
            }
          }
          break;

        default:
          break;
      }
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleAddCourierModal = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    // If there are no validation errors, proceed to next step
    if (Object.keys(validationErrors).length === 0) {
      const payload = {
        username: loggedInUserName,
        customerCode: columnData?.customerCode || "",
        smsUnits: Number(formData.smsClawback) || 0,
        rcsUnits: Number(formData.rcsClawback) || 0,
      };

      axiosPostApi(apiList.CREATE_CLAWBACK_TOPUP_REQUEST, payload)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: response?.data?.message,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            });
            callApi();
            handleClose();
            // handleClearData();
          } else if (response?.status === 200 && !response?.data?.status) {
            CustomAlert({
              title: "Failed to Request",
              text: response.data.message,
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing Wallet request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the Wallet request. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    // setLoading(true);

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          callApi(1);
        } else {
          // Handle error case here if necessary
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                // width: "597px",
                width: "550px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">Clawback SMS/RCS</h5>
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <div className="row mt-2">
                    <div>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="currentSmsCount">
                              Current SMS Balance (Qty)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="currentSmsCount"
                              placeholder="0"
                              value={columnData?.smsBalance}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="currentRcsBalance">
                              Current RCS Balance (Qty)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="currentRcsBalance"
                              placeholder="0.00"
                              value={columnData?.rcsBalance}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label htmlFor="smsClawback">SMS Clawback</label>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control placeholder:text-sm"
                              id="smsClawback"
                              placeholder="Enter SMS units to clawback"
                              value={formData.smsClawback || ""}
                              style={{ textAlign: "right" }}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,9}$/.test(value)) {
                                  handleInputChange(e);
                                }
                              }}
                              onBlur={handleBlur}
                              inputMode="numeric"
                            />
                            {errors.smsClawback ? (
                              <span className="error">
                                {errors.smsClawback}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="rcsClawback">RCS Clawback</label>
                            <input
                              type="text"
                              className="form-control placeholder:text-sm"
                              id="rcsClawback"
                              placeholder="Enter RCS units to clawback"
                              value={formData.rcsClawback}
                              style={{
                                textAlign: "right",
                              }}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,9}$/.test(value)) {
                                  handleInputChange(e);
                                }
                              }}
                              onBlur={handleBlur}
                              inputMode="numeric"
                            />
                            {errors.rcsClawback ? (
                              <span className="error">
                                {errors.rcsClawback}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="closingSmsBalance">
                              Closing SMS Balance (Qty)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="closingSmsBalance"
                              placeholder="0.00"
                              value={formData?.closingSmsBalance || ""}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="closingRcsBalance">
                              Closing RCS Balance (Qty)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="closingRcsBalance"
                              placeholder="0.00"
                              value={formData.closingRcsBalance}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>

                      <hr />
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal mt-2"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingTop: "0px",
                    gap: "16px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={handleAddCourierModal}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClawbackSmsRcsModal;
